<template>
  <div
    :class="`w-fit py-[6px] px-[10px] rounded-full border-[1px] text-[12px] font-medium rounded-full px-[4px] py-[2px] border-[1px] mb-0 ${statusPillConfig.class}`"
  >
    {{ statusPillConfig.label }}
  </div>
</template>

<script>
import { CREATOR_STATUS_STYLE } from '../config'

export default {
  props: {
    status: {
      type: String,
      default: '-',
    },
  },
  computed: {
    statusPillConfig() {
      return CREATOR_STATUS_STYLE[this.status.toLowerCase()] || {
        label: '-',
        class: 'border-none',
      }
    },
  },
}
</script>
